// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Layout$PrezzeeRibbon from "../../../theme/Theme__Layout.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var block = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.borderRadius(Theme__Layout$PrezzeeRibbon.Personal.borderRadius),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexGrow(1),
      BsCssJs$PrezzeeRibbon.flexShrink(1),
      BsCssJs$PrezzeeRibbon.overflow("hidden"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.desktop, [BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.tablet, [BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.mobile, [BsCssJs$PrezzeeRibbon.flexDirection("column")])
    ]);

var defaultBgColor = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.mobileHeroBackground)]);

var imageLayer = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.overflow("hidden"),
      BsCssJs$PrezzeeRibbon.borderTopRightRadius(Theme__Layout$PrezzeeRibbon.Personal.borderRadius),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.tabletOrDesktop, [
            BsCssJs$PrezzeeRibbon.position("absolute"),
            BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.zero),
            BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.zero),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.unsafe("backgroundSize", "auto 100%"),
            BsCssJs$PrezzeeRibbon.backgroundPosition("right"),
            BsCssJs$PrezzeeRibbon.backgroundRepeat("noRepeat"),
            BsCssJs$PrezzeeRibbon.borderBottomRightRadius(Theme__Layout$PrezzeeRibbon.Personal.borderRadius)
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.mobile, [
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.vw(70)),
            BsCssJs$PrezzeeRibbon.unsafe("backgroundSize", "cover"),
            BsCssJs$PrezzeeRibbon.backgroundPosition(BsCssJs$PrezzeeRibbon.pct(20)),
            BsCssJs$PrezzeeRibbon.backgroundRepeat("noRepeat"),
            BsCssJs$PrezzeeRibbon.borderTopLeftRadius(Theme__Layout$PrezzeeRibbon.Personal.borderRadius)
          ])
    ]);

var alignLeft = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.tabletOrDesktop, [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.backgroundPosition("left"))])]);

var Styles = {
  block: block,
  defaultBgColor: defaultBgColor,
  imageLayer: imageLayer,
  alignLeft: alignLeft
};

function LargeHeroTile__Background(props) {
  var alignBackground = props.alignBackground;
  var backgroundColorClassName = props.backgroundColorClassName;
  var backgroundImageClassName = props.backgroundImageClassName;
  var backgroundImageClassName$1 = backgroundImageClassName !== undefined ? backgroundImageClassName : "";
  var backgroundColorClassName$1 = backgroundColorClassName !== undefined ? backgroundColorClassName : defaultBgColor;
  var alignBackground$1 = alignBackground !== undefined ? alignBackground : /* Right */1;
  var alignmentCss = alignBackground$1 ? "" : alignLeft;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            className: Classnames([
                                  imageLayer,
                                  alignmentCss,
                                  backgroundImageClassName$1
                                ])
                          }),
                      props.children
                    ],
                    className: block
                  }),
              className: Classnames([
                    block,
                    backgroundColorClassName$1
                  ])
            });
}

var make = LargeHeroTile__Background;

export {
  Styles ,
  make ,
}
/* block Not a pure module */
